import { PAGINATION } from "@src/mock/data/pagination";
import { COUPON_LIST } from "@src/mock/data/coupon";

export default {
  title: '取得會員優惠券列表',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "items": COUPON_LIST,
          "pagination": PAGINATION
        }
      }
    },
  ]
}
